"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiAutocompleteOverrides = function (_a) {
    var spacing = _a.spacing, shape = _a.shape, palette = _a.palette;
    return ({
        inputRoot: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid " + palette.secondary.main,
            },
            '&&[class*="MuiOutlinedInput-root"]': {
                paddingTop: 0,
                paddingBottom: 0,
            },
            '&&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
                paddingTop: spacing(6),
                paddingBottom: spacing(3),
                paddingLeft: spacing(2),
                "&:disabled": {
                    opacity: 0.3,
                },
            },
        },
        focused: {
            '&[aria-expanded="false"]': {
                borderRadius: shape.borderRadius,
                border: "1px solid " + palette.text.primary,
            },
            '&[aria-expanded="true"]': {
                backgroundColor: palette.background.paper,
            },
        },
        paper: {
            margin: 0,
            borderBottom: "1px solid " + palette.secondary.main,
            borderLeft: "1px solid " + palette.secondary.main,
            borderRight: "1px solid " + palette.secondary.main,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
        },
        option: {
            color: palette.text.secondary,
            // Hover
            '&[data-focus="true"]': {
                color: palette.primary.contrastText,
                backgroundColor: palette.primary.main,
                marginLeft: spacing(2),
                marginRight: spacing(2),
                paddingLeft: spacing(2),
                borderRadius: shape.borderRadius,
            },
            // Selected
            '&[aria-selected="true"]': {
                color: palette.text.primary,
                backgroundColor: palette.background.paper,
            },
        },
    });
};
//# sourceMappingURL=MuiAutocomplete.js.map